<loader></loader>
<toaster top right></toaster>
<router-outlet></router-outlet>